import { literal, number, object, string } from 'zod';

import { IS_POSITIVE, IS_REQUIRED } from '@occc-app/lib/constants/validationMessages';
import { withIsEnabled } from '@occc/validation';

export const TransactionLimitEnabledSchema = object({
  id: string().optional(),
  limit: number({ required_error: IS_REQUIRED }).gt(0, { message: IS_POSITIVE }),
});

export const TransactionLimitDisabledSchema = object({
  id: string().optional(),
  limit: number().optional(),
});

export const TransactionLimitDisabledSchemaWithIsEnabled = TransactionLimitDisabledSchema.extend({
  isEnabled: literal(false).default(false),
});

export const TransactionLimitSchema = withIsEnabled(
  TransactionLimitEnabledSchema,
  TransactionLimitDisabledSchema,
);
